import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { ChartSection } from "../styles/Chat.styled";

interface ChartProps {
  usages: any;
  address: any;
}

export const UsagesChart = (props: ChartProps) => {
  const { usages, address} = props;
  let data = getData(usages);
  let location = `${address.address}, ${address.city}, ${address.state_code} ${address.zipcode}`

  return <ChartSection>
    <h5> Estimated Usage</h5>
    <ResponsiveContainer height={200}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="month" interval={1} />
        <YAxis />
        <Tooltip itemStyle={{ color: "black" }} separator=" " />
        <Bar dataKey="value" fill="#e8ecec" name=" " unit=" kwh" />
      </BarChart>
    </ResponsiveContainer>
    <h5>{location}</h5>
    <h6>ESIID: {address.esiid}</h6>
  </ChartSection>;
};

const getData = (props: any) => {
  // let { usages } = props;
  const data = [
    { month: "Jan", value: 0 },
    { month: "Feb", value: 0 },
    { month: "Mar", value: 0 },
    { month: "Apr", value: 0 },
    { month: "May", value: 0 },
    { month: "Jun", value: 0 },
    { month: "Jul", value: 0 },
    { month: "Aug", value: 0 },
    { month: "Sept", value: 0 },
    { month: "Oct", value: 0 },
    { month: "Nov", value: 0 },
    { month: "Dec", value: 0 },
  ];

  let _usages = Object.values(props);
  let _data: any[] = [];
  data.forEach((o: any, index: number) => {
    o.value = _usages[index];
    _data.push(o);
  });
  return _data;
};
